export default __webpack_public_path__ + "static/media/iotex-logo.e252f0e9.png";